/** Picks v2 or v1 of the Role Management list based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import RolesPage   from './RolesPage';
import RolesPageV2 from './v2/RolesPageV2';

export default function RolesPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? RolesPageV2 : RolesPage;
  return <Component {...props} />;
}
